<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="desserts"
        hide-default-footer
        disable-pagination
        :height="700"
        :fixed-header="true"
        class="golfGroupTbody"
    >
    <template v-slot:[`item.adminflags`]="{ item }">
        <v-checkbox v-model="item.adminflags"/>
    </template>
    <template v-slot:[`item.golfflags`]="{ item }">
        <v-checkbox v-model="item.golfflags"/>
    </template>
    </v-data-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="MakeMutationObject()">変更</v-btn>
    </v-card-actions>
    <ChangeOverlay
      page-name="権限"
      @processing="UpdateOperationAccessesList"
      @cancel="closeChangeOverLay"
      :process-result="process"
      :OverlaySwitch="changeOverlay"
    />
  </div>
</template>

<script>
import { GET_ALL_OPERATION_ACCESSES_LIST, UPDATE_OPERATION_ACCESSES } from '@/constants/operation_accesses';
import ChangeOverlay from '@/components/overlay/ChangeOverlay';
import { authorityMixin } from '@/views/authorityMixin';
import { CODE_MASTER } from '../../config';

export default {
    components: {
        ChangeOverlay
    },
    mixins: [authorityMixin],
    data () {
        return {
            changeOverlay: false,
            processing: false,
            loadingCount: 0,
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            // v-data-tableのアイテム
            desserts: [],
            // ログイン者の情報
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // v-data-tableのヘッダー
            headers: [
                { text: 'コード名', value: 'display_vue_name', sortable: false, width: '30%' },
                { text: '画面', value: 'element_name', sortable: false, width: '30%' },
                { text: 'システム管理者', value: 'adminflags', sortable: false, width: '20%' },
                { text: 'ゴルフ場一般', value: 'golfflags', sortable: false, width: '20%' }
            ]
        };
    },
    computed: {
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            await this.GetAllOperationAccessesList();
            this.admin = await this.getLoginAdmin();
        },
        /** --------------------------------------------
        * 権限取得表示処理
        * -------------------------------------------- */
        GetAllOperationAccessesList: async function () {
            let me = this;
            me.loadingOn();
            let res = await this.$apollo.query({
                query: GET_ALL_OPERATION_ACCESSES_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE
                }
            });
            me.desserts = res.data.GetAllOperationAccessList.AllOperationAccessList;
            me.desserts[0].display_vue_name = me.desserts[0].vue_name;
            var lookVueName = me.desserts[0].vue_name;
            for (let operationList of me.desserts) {
                operationList.golfflags = Boolean(operationList.golf_element_control);
                operationList.adminflags = Boolean(operationList.system_element_control);
                if (operationList.vue_name !== lookVueName) {
                    operationList.display_vue_name = operationList.vue_name;
                    lookVueName = operationList.vue_name;
                }
            }
            me.loadingOff();
        },
        /** --------------------------------------------
        * 更新用オブジェクト作成
        * -------------------------------------------- */
        MakeMutationObject: function () {
            let me = this;
            let data = [];
            // 変更されたデータを調べて更新用データを作成する
            for (let operationList of me.desserts) {
                let obj = {};
                // Booleanを数値に変換
                operationList.golfflags = Number(operationList.golfflags);
                operationList.adminflags = Number(operationList.adminflags);
                // 取得してきたelement_controlと一致しなければ作成
                if (operationList.golf_element_control !== operationList.golfflags) {
                    obj = {
                        golf_group_code: process.env.VUE_APP_GROUP_CODE,
                        element_control: operationList.golfflags,
                        element_id: operationList.element_id,
                        element_name: operationList.element_name,
                        user_div: CODE_MASTER.AUTHORITY_GOLFCOUSE_ADMIN,
                        vue_id: operationList.vue_id,
                        vue_name: operationList.vue_name
                    };
                    data.push(obj);
                }
                if (operationList.system_element_control !== operationList.adminflags) {
                    obj = {
                        golf_group_code: process.env.VUE_APP_GROUP_CODE,
                        element_control: operationList.adminflags,
                        element_id: operationList.element_id,
                        element_name: operationList.element_name,
                        user_div: CODE_MASTER.AUTHORITY_SYSTEM_ADMIN,
                        vue_id: operationList.vue_id,
                        vue_name: operationList.vue_name
                    };
                    data.push(obj);
                }
            }
            me.UpdateOperationAccessesList(data);
        },
        /** --------------------------------------------
        * 権限更新
        * @parm data 更新用オブジェクト
        * -------------------------------------------- */
        UpdateOperationAccessesList: function (data) {
            let me = this;
            me.processing = true;
            this.$apollo.mutate({
                mutation: UPDATE_OPERATION_ACCESSES,
                variables: {
                    OperationAccessesList: data
                }
            }).then(res => {
                me.process.result = res.data.UpdateOperationAccesses.result;
                if (res.data.UpdateOperationAccesses.result === 0) {
                    me.process.resultText = this.$t('result.error.change');
                    me.changeOverlay = true;
                    me.processing = false;
                } else if (res.data.UpdateOperationAccesses.result === 1) {
                    me.process.resultText = this.$t('result.success.change');
                    me.changeOverlay = true;
                    me.processing = false;
                }
                me.GetAllOperationAccessesList();
            }).catch(err => {
                me.process.resultText = this.$t('result.error.change');
                me.changeOverlay = true;
                me.processing = false;
                this.error = err;
            });
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる
         * ---------------------------------------------- */
        closeChangeOverLay () {
            this.process.result = '';
            this.changeOverlay = false;
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
            this.$store.commit('loading/setIsLoading', true);
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function () {
            this.loadingCount--;
            if (this.loadingCount === 0) {
                this.$store.commit('loading/setIsLoading', false);
            }
        }
    }
};
</script>

<style scoped>
    .v-data-table ::v-deep td{
        max-width: 500px;
    }

    .v-data-table ::v-deep i{
        font-size: 15px;
    }

    .editBtn{
        color: #1B5E20;
        background: Transparent;
        text-decoration: underline;
        margin-right: 20px;
    }

    .deleteBtn {
        color: #d63200;
        background: Transparent;
        text-decoration: underline;
    }
</style>
